// Avatar de un chat (2026-10-07): la foto de perfil si la hay (bajada una vez y
// guardada en memoria), si no las iniciales con un color fijo por persona.
import { rec_React as React } from "../../runtime/index.jsx";
import { IconoGrupo } from "./iconos.jsx";
import { colorDe, iniciales } from "./util-gestor.js";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useEffect = (...a) => React.useEffect(...a);
const useState = (...a) => React.useState(...a);

/** chatId → Promise<url | null>: cada foto se baja una sola vez por sesión. */
const fotos = new Map();

export function Avatar({ chat, api, grande = false, className = `` }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!chat.tieneFoto || !api) { setUrl(null); return undefined; }
    let vivo = true;
    if (!fotos.has(chat.id)) fotos.set(chat.id, api.foto(chat.id).catch(() => null));
    fotos.get(chat.id).then((u) => { if (vivo) setUrl(u); });
    return () => { vivo = false; };
  }, [chat.id, chat.tieneFoto, api]);
  const clase = `gx-avatar${grande ? ` grande` : ``} ${className}`;
  if (url) return <img className={`${clase} gx-avatar-foto`} src={url} alt="" />;
  return (
    <span className={clase} style={{ "--av": colorDe(chat.nombre) }} aria-hidden="true">
      {chat.esGrupo ? <IconoGrupo /> : iniciales(chat.nombre)}
    </span>
  );
}
